import React, { useState } from 'react';
import { submitCommissionRequest } from '../api/commissions';
import '../styles/CommissionForm.css';

const CommissionForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    projectType: '',
    description: '',
    budget: '',
    deadline: '',
  });
  
  const [formStatus, setFormStatus] = useState({
    submitting: false,
    success: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Simple validation
    if (!formData.name || !formData.email || !formData.description) {
      setFormStatus({
        submitting: false,
        success: false,
        error: "Please fill in all required fields."
      });
      return;
    }
    
    setFormStatus({ submitting: true, success: false, error: null });
    
    try {
      await submitCommissionRequest(formData);
      
      setFormStatus({
        submitting: false,
        success: true,
        error: null
      });
      
      // Reset form after successful submission
      setFormData({
        name: '',
        email: '',
        projectType: '',
        description: '',
        budget: '',
        deadline: '',
      });
      
      // Clear success message after delay
      setTimeout(() => {
        setFormStatus(prev => ({ ...prev, success: false }));
      }, 5000);
      
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus({
        submitting: false,
        success: false,
        error: "Failed to submit your request. Please try again later."
      });
    }
  };

  return (
    <div className="commission-form-container">
      {formStatus.success ? (
        <div className="success-message">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <h3>Request Submitted!</h3>
          <p>Thank you for your interest. I'll review your project details and get back to you via email soon.</p>
        </div>
      ) : (
        <form className="commission-form" onSubmit={handleSubmit}>
          {formStatus.error && (
            <div className="form-error">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <span>{formStatus.error}</span>
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="name">Name <span className="required">*</span></label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email <span className="required">*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="projectType">Project Type</label>
            <select
              id="projectType"
              name="projectType"
              value={formData.projectType}
              onChange={handleChange}
            >
              <option value="">Select a project type</option>
              <option value="character">Character Model/Render</option>
              <option value="environment">Environment/Scene</option>
              <option value="animation">Animation</option>
              <option value="other">Other</option>
            </select>
          </div>
          
          <div className="form-group full-width">
            <label htmlFor="description">Project Description <span className="required">*</span></label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="5"
              required
              placeholder="Please describe your project, including any specific requirements or references."
            ></textarea>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="budget">Budget (USD)</label>
              <input
                type="text"
                id="budget"
                name="budget"
                value={formData.budget}
                onChange={handleChange}
                placeholder="e.g. $300-500"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="deadline">Deadline (if any)</label>
              <input
                type="date"
                id="deadline"
                name="deadline"
                value={formData.deadline}
                onChange={handleChange}
                min={new Date().toISOString().split('T')[0]}
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={formStatus.submitting}
          >
            {formStatus.submitting ? 'Submitting...' : 'Submit Request'}
          </button>
        </form>
      )}
    </div>
  );
};

export default CommissionForm;